// Help as the Application API serves it (`GET /api/help`): the business's help topics, generated from its Business
// Tree, in English or Hindi, those the person may see, with every word searched for in them.
import { call, type Fetch } from "../http.js";
import type { Language } from "../i18n/language.js";

export interface HelpTopic {
  readonly id: string;
  readonly kind: "value_stream" | "task" | "artifact";
  /** English when its Hindi is not all written yet. */
  readonly language: Language;
  readonly title: string;
  readonly text: string;
  readonly fallbackNote?: string;
}

export interface HelpView {
  readonly topics: readonly HelpTopic[];
  /** How many matched; at most 60 are answered. */
  readonly matched: number;
}

export interface HelpApi {
  topics(language: Language, words?: string): Promise<HelpView>;
}

export const createHelpApi = (fetcher: Fetch): HelpApi => ({
  topics: (language, words = "") => {
    const query = new URLSearchParams({ language });
    if (words.trim()) query.set("q", words.trim());
    return call<HelpView>(fetcher, `/api/help?${query.toString()}`);
  },
});
